export const API_KEY = 'a4afb29e183056caf092f42600df8fd7';
export const BASE_URL = `https://api.openweathermap.org/data/2.5/weather`;